export default __webpack_public_path__ + "static/media/icon3.00bcaa95.svg";